import { withStateHandlers } from 'recompose'


export default withStateHandlers(
  { subscription: '' },
  { setSubscription: () => subscriptionId => ({ subscription: subscriptionId }) }
)



// WEBPACK FOOTER //
// ./components/hoc/subscriptionSelect.js